export const serviceCategories = [
  {
    id: 1,
    icon: "ri-file-list-3-line",
    title: "Bookkeeping",
    description: "Organized, accurate books — weekly or monthly",
    items: [
      "Monthly & weekly bookkeeping",
      "Bank & credit card reconciliations",
      "Catch-up bookkeeping",
      "Cleanup of messy books",
    ],
  },
  {
    id: 2,
    icon: "ri-bar-chart-box-line",
    title: "Financial Reporting",
    description: "Clear insights into your financial health",
    items: [
      "Profit & Loss statements",
      "Balance sheet preparation",
      "Financial analysis & reporting",
      "Accounting system setup",
    ],
  },
  {
    id: 3,
    icon: "ri-money-dollar-circle-line",
    title: "Tax & Payroll",
    description: "Florida sales tax specialists & payroll done right",
    items: [
      "Sales tax filing (Florida specialist)",
      "Payroll processing",
      "Tax compliance & planning",
    ],
    highlight: true,
  },
  {
    id: 4,
    icon: "ri-settings-3-line",
    title: "QuickBooks & Advisory",
    description: "Setup, cleanup & ongoing strategic guidance",
    items: [
      "QuickBooks setup & cleanup",
      "Monthly advisory services",
      "Financial strategy & planning",
    ],
  },
];
